import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

const TrashIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
    <path d="M9 3V4H4V6H5V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V6H20V4H15V3H9ZM7 6H17V20H7V6ZM9 8V18H11V8H9ZM13 8V18H15V8H13Z"/>
  </svg>
);

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  return (
    <div style={{
      background: "#ffffff",
      borderRadius: 10,
      boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
      border: "1.5px solid #6366f1",
      minWidth: 180,
      maxWidth: 200,
      position: "relative",
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif",
    }}>
      {/* Header compacto */}
      <div style={{
        display: "flex",
        alignItems: "center",
        background: "#f5f3ff",
        padding: "8px 10px",
        borderBottom: "1px solid #e0e7ff",
        borderRadius: "10px 10px 0 0",
        gap: 8,
      }}>
        <div style={{
          width: 24, height: 24, borderRadius: 6,
          background: "#6366f1",
          display: "flex", alignItems: "center", justifyContent: "center",
          flexShrink: 0,
        }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="white">
            <path d="M8 5v14l11-7z"/>
          </svg>
        </div>
        <span style={{ fontWeight: 600, fontSize: 12, color: "#0f172a", flex: 1 }}>
          Início do Fluxo
        </span>
        <button
          style={{
            width: 20, height: 20, borderRadius: 5,
            border: "1px solid #e2e8f0", background: "#fff",
            display: "flex", alignItems: "center", justifyContent: "center",
            cursor: "pointer", color: "#94a3b8", padding: 0,
          }}
          title="Excluir"
          onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("delete"); }}
        >
          <TrashIcon />
        </button>
      </div>

      {/* Corpo compacto */}
      <div style={{ padding: "8px 10px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span style={{ fontSize: 11, color: "#64748b" }}>Próxima etapa</span>
      </div>

      <Handle
        type="source"
        position="right"
        id="a"
        className="node-handle-out"
        style={{ right: -7, top: "50%", transform: "translateY(-50%)" }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
